import { legacy_createStore as createStore, applyMiddleware } from "redux";
//import { legacy_createStore as createStore } from 'redux';
import createSagaMiddleware from "redux-saga";
//import { composeWithDevTools } from "redux-devtools-extension";
import { rootReducer } from "./reducers";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
  // composeWithDevTools(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);
